import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { IQuestionComponent } from 'app/interfaces/IQuestionComponent'
import { AbstractControl } from '@angular/forms'
import { SurveyViewerService } from 'app/modules/survey/survey-viewer/services/survey-viewer.service'
import { Phone } from 'app/models/questions/Phone'

@Component({
    selector: 'app-phone',
    templateUrl: './phone.component.html',
    styleUrls: ['./phone.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PhoneComponent implements IQuestionComponent, OnInit {

  @Input() isSmallScreen: boolean
  @Input() question: Phone
  @Input() activeLang: string

  questionFormControl: AbstractControl

  labels = {
    enterPhone: {
      fr: 'Entrez votre numéro de téléphone',
      en: 'Enter your phone number'
    }
  }

  constructor(
    public surveyViewerService: SurveyViewerService
  ) { }

  ngOnInit(): void {
    this.questionFormControl = this.surveyViewerService.activeSurvey$.value.form.get(this.question.key)
      .get(this.question.rowKeys.pop()).get(this.question.commentsControlName).get(this.question.phoneFormControlName)
      this.surveyViewerService.changeFormUpdateStrategy(this.questionFormControl, 'blur');
  }

}
